<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />
  <div v-else class="animated fadeIn">
    <default-heading class="mt-3">
      {{ customer_coord ? customer_coord.name : 'TBD' }}

      <template #right>
        <b-button
          variant="primary"
          class="ml-1"
          to="/customer-coords"
        >
          <i class="fal fa-list" />
        </b-button>

        <b-button
          variant="warning"
          class="ml-1 text-white"
          :to="`/customer-coords/${customer_coord_id}/edit`"
        >
          <i class="fal fa-pencil" />
        </b-button>

        <b-button
          variant="danger"
          class="ml-1"
          @click="showDeleteModal"
        >
          <i class="fal fa-trash" />
        </b-button>
      </template>
    </default-heading>

    <div>
      <div class="mt-4" />

      <MapboxMap :initial-coordinates="coords" :interactive="false" />
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import CustomerCoordModel from '@/models/crm/CustomerCoordModel'
import CustomerFieldServerTable from '@/components/crm/customer/CustomerFieldServerTable'
import MapboxMap from '@/components/shared/MapboxMap'

export default {
  name: 'CustomerCoordDetail',
  components: {
    DefaultHeading,
    LoadingOverlay,
    CustomerFieldServerTable,
    MapboxMap
  },
  data () {
    return {
      customer_coord_id: this.$route.params.id || null,
      loading: true,
      customer_coord: null
    }
  },
  computed: {
    coords () {
      return {
        lat: this.customer_coord ? this.customer_coord.lat : null,
        lng: this.customer_coord ? this.customer_coord.long : null
      }
    }
  },
  methods: {
    async fetchCustomerCoord () {
      const model = new CustomerCoordModel({ id: this.customer_coord_id })
      model.fetch().then(() => {
        this.customer_coord = model
        this.loading = false
      })
    },

    showDeleteModal () {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this coord?', {
        title: 'Delete Coord',
        modalClass: ["modal-danger"],
        size: "sm",
        okVariant: "danger",
        okTitle: "YES",
        cancelTitle: "NO",
        footerClass: "p-2",
        centered: true,
      })
      .then(confirm => {
        if (confirm) {
          const model = new CustomerCoordModel({ id: this.customer_coord_id })
          model.delete().then(() => {
            this.$bvToast.toast('', {
              title: 'Coord deleted',
              variant: 'success'
            })

            this.$router.push('/customer-coords')
          })
        }
      })
    }
  },
  mounted () {
    this.fetchCustomerCoord()
  }
}
</script>
